import { render, staticRenderFns } from "./LevelSettings.vue?vue&type=template&id=46132044&scoped=true&"
import script from "./LevelSettings.vue?vue&type=script&lang=js&"
export * from "./LevelSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46132044",
  null
  
)

export default component.exports